import gql from 'graphql-tag'

export const DOCUMENT_LAYOUT_QUERY = gql`
    query documentLayout(
        $id: ID!
    ) {
        documentLayout(
            id: $id
        ) {
            id
            name
            name_language_versions
            owner {
                id
                company_name
            }
            pageBackground {
                id
                name
                size
            }
            page_margins
            is_default
            created_at
            updated_at
        }
    }
`
